import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { ITask } from "./types";

interface IGetTaskByIdResponse {
  success: boolean;
  message: string;
  data: ITask;
}

export const getTaskById = async (taskId: string): Promise<IGetTaskByIdResponse> => {
  try {
    const response = await apiClientSource.get(`/task-service/api/tasks/${taskId}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al obtener los detalles de la tarea");
    throw error;
  }
}; 